module.exports = __webpack_public_path__ + "img/wp-new-habit-card24.0470fd32.png";